// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "_chunks/chunk." + (chunkId === 5076 ? "prototypejs" : chunkId) + ".js";
};